import { baseEmailAssets, baseEmailTheme, TenantInfo } from '../common';
import { quoteTerms } from './quote-terms';
import { tos } from './tos';

export const tenant = {
  id: 'pace',
  name: 'Airrate.com by Pace Global Logistics',
  isSystemTenant: false,
  domains: [
    'pace.localhost',
    'pace.demo.pelicargo.dev',
    'pace.tenant.pelicargo.dev',
    'airrate.com',
    /pace\.staging-\d+\.pelicargo\.dev/,
  ],
  customerTheme: {
    colors: {
      primary: {
        '50': '#E9F3FB',
        '100': '#DEECFA',
        '200': '#BBD9F5',
        '300': '#80BAF0',
        '400': '#2A8EEC',
        '500': '#085399',
        '600': '#074E91',
        '700': '#044079',
        '800': '#01294F',
        '900': '#000810',
      },
    },
    logoDims: {
      height: 30,
      width: 130,
    },
    fullLogoDims: {
      height: 50,
      width: 180,
    },
  },
  emailTheme: {
    ...baseEmailTheme,
    primary: '#2A8EEC',
  },
  emailAssets: {
    ...baseEmailAssets,
    'logo-dark': 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/pace/pace_logo_dark.svg',
    'logo-dark-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/pace/pace_logo_tagline.svg',
    'logo-light':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/pace/pace_logo_light.svg',
    'logo-light-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/pace/pace_logo_tagline.svg',
    twitterUrl: 'https://to-be-determined/',
    facebookUrl: 'https://to-be-determined/',
    linkedinUrl: 'https://to-be-determined/',
    siteUrl: 'https://pacegloballogistics.com/',
    logo: 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/pace/logo.png',
  },
  admin: {
    cruds: {
      accounts: true,
      providers: false,
      airports: false,
      contacts: true,
      instructions: false,
      users: true,
      backlogs: false,
      'ai-inbox': false,
      surcharges: false,
      rates: false,
      'route-editor': false,
      configuration: false,
    },
    inbox: {
      requestDrawers: {
        // Provider Facing
        ProviderQuoting: false,
        AirlineBooking: false,
        RequestSchedule: false,
        BookingChange: false,
        BookingCancel: false,

        // Customer Facing
        QuoteUpdate: true,
        BookingConfirmation: true,
        NewRate: true,
        RequestClarifications: true,
        Contact: true,
        GenericEmailToFF: true,
        StatusUpdate: true,
      },
    },
    features: {
      instructionCreation: false,
    },
  },
  accountTypes: {
    IAC: false,
    IATA: false,
    ORGANIZATION: false,
    UNCERTIFIED: true,
  },
  customer: {
    networks: {
      showOnSignup: true,
      options: [
        'AFBN',
        'AirDX',
        'AON',
        'BLOC',
        'COOP',
        'EGLN',
        'GCA',
        'GKF',
        'GLA',
        'LogX',
        'MiPharma',
        'OLO',
        'Pangea',
        'PPL',
        'Prolog',
        'TWIG',
        'UNFN',
        'WCA eCommerce',
        'X2 Elite',
        'Logifem',
        'None of Above',
      ],
    },
    freightServices: {
      UNCERTIFIED: ['EXW', 'FCA'],
      default: ['EXW', 'FCA'],
    },
    requestFormDefaults: {
      freight_service: 'EXW',
      is_consolidated: true,
      extra_freight_services: ['AES'],
    },
  },
  termsOfService: tos,
  quoteTerms,
  helpUrl: 'https://docs.google.com/document/d/182b1al8Uyn5RobuZlV7MQJ0BYnonlJJIOwaqii6AmBk/edit?usp=sharing',
} as const satisfies TenantInfo<'pace'>;
